"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "\n    <script>\n        var lastHeight;\n\n        function getDocHeight(doc) {\n            return doc.body.offsetHeight || 0;\n        }\n\n        function sendHeight() {\n            var height = getDocHeight(document);\n\n            if (height === lastHeight) {\n                return;\n            }\n\n            lastHeight = height;\n\n            window.parent.postMessage(\n                JSON.stringify({ height: height }),\n                '*'\n            );\n        }\n\n        window.setInterval(sendHeight, 500);\n    </script>\n";
//# sourceMappingURL=sendHeightScript.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedHtml/sendHeightScript.js
 ** module id = 505
 ** module chunks = 1
 **/